import React from "react";
import Marquee from "react-fast-marquee";
import styles from "./TechStackCarousel.module.css";
import { logos } from "../../../jsonData/data";

const TechStackCarousel = () => {
  return (
    <div className={styles["tech-carousel-container"]}>
      <Marquee
        speed={50}
        gradient={false}
        pauseOnHover={true}
        direction="left"
        loop={10}
      >
        {logos.map((logo) => {
          const IconComponent = logo.src;
          return (
            <div key={`first-${logo.name}`} className={styles["tech-logo"]}>
              <IconComponent />
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

export default TechStackCarousel;
